import { sizes } from '../../../const/sizes';
export const dialogSizeMap = {
    sm: sizes.dialog.widthSm,
    md: sizes.dialog.widthMd,
    lg: sizes.dialog.widthLg,
};
